/* src/app/pages/project/map/repository/import-wizard/components/geospatial/import-wizard-geospatial.component.scss */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 1rem 1.5rem;
}
.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-shrink: 0;
  margin-bottom: 0.5rem;
}
.header-left {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
}
.modal-title {
  text-decoration: underline;
  text-decoration-thickness: 0.2rem;
  text-decoration-color: var(--color-primary);
  color: var(--color-text);
  text-underline-offset: 0.3rem;
  font-weight: bold;
  text-transform: uppercase;
  margin: 0;
  flex-shrink: 0;
}
.file-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  max-width: 100%;
  min-width: 0;
  border-radius: 4px;
  padding: 3px 0px;
  width: fit-content;
}
.file-badge svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  color: var(--color-primary);
}
.file-name {
  font-size: 0.78rem;
  color: var(--color-text);
  font-family: monospace;
  letter-spacing: 0.01em;
  line-height: 1;
}
.stepper-container {
  flex-shrink: 0;
}
.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
  flex-shrink: 0;
}
.button-container > button {
  background: var(--color-primary);
  color: #2a2a2a;
  border: none;
  border-radius: 6px;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  width: fit-content;
  transition: all 0.2s ease;
}
.button-container > button:hover {
  background: var(--color-primary);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 150, 65, 0.3);
}
.button-container > button:active {
  transform: translateY(0);
}
/*# sourceMappingURL=import-wizard-geospatial.component-RIL6Q7IG.css.map */
